import {Link, graphql } from 'gatsby'
import React from 'react'
import Layout from '../../components/Layout'
import * as styles from '../../styles/projects.module.css'
import { GatsbyImage } from "gatsby-plugin-image"



export default function Projects({data}) {
    
    console.log(data)
    const projects = data.allMarkdownRemark.nodes
    
    return (
        <Layout>
        <div className={styles.portfolio}>
            <h2> Protfolio </h2>
            <h3> Projects and websites I have created </h3>
            <div className={styles.projects}>

                {projects.map(project=>(
                    <Link to={"/torch/"+ project.frontmatter.slug} key={project.id}>
                    

                    <div>
                       
                        <GatsbyImage image={project.frontmatter.thumb.childImageSharp.gatsbyImageData} />
                        <h3> { project.frontmatter.title}</h3>
                        <p> { project.frontmatter.stack} </p>


                    </div>

                    </Link>

                
                ))}
            </div>


        </div>
        </Layout>
    )
}




export const query = graphql`

query ProjectPage {
  allMarkdownRemark(
    sort: {fields: frontmatter___date, order: DESC}
    filter: {frontmatter: {domain: {eq: "torch"}}}
  ) {
    nodes {
      frontmatter {
        slug
        stack
        title
        thumb {
          childImageSharp {
            gatsbyImageData(layout: CONSTRAINED)
          }
        }
      }
    }
  }
}

  

`